const $ = jQuery.noConflict();
import 'slick-carousel';
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);
'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),
	$domBannerSlider: $('.js-banner__slider'),
	$domProductsSlider: $('.js-products__slider-wrapper'),
	$domSingleProductSlider: $('.js-single-product__slider-wrapper'),
	$domSingleProductPreviewSlider: $('.js-single-product__slider-preview'),
	$domProductInfoBoxSlider: $('.custom-product-slide'),

	/** @description Initialize. */
	init: function() {
		this.initGallerySlider();
		if ($('.banner__content').length > 1) {
			this.bannerSlider();
		}
		this.productSlider();
		this.singleProductSlider();
		this.productInfoBoxSlider();
	},

	/** @description Set and run gallery slider. */
	initGallerySlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSlider, config);
	},

	bannerSlider: function() {
		const baseConfig = new SliderBaseConfig(1);

		const extraConfig = {
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
			dots: true,
			appendDots: $('.js-banner__slider-dots'),
			fade: true
		};

		const config = {
			...baseConfig,
			...extraConfig
		};

		this.runSlider(this.$domBannerSlider, config);
	},

	productSlider: function() {
		const baseConfig = new SliderBaseConfig(5);

		Sliders.$domProductsSlider.each((i, el) => {
			// Sliders.$domProductsSlider.imagesLoaded().done(function() {
				// Sliders.$domProductsSlider.on('init', () => {
				// 	Sliders.$domProductsSlider.parent().addClass('show-slider');
				// });
				const left = $(el).parents('.js-products').find('.js-products__slider-arrow-left');
				const right = $(el).parents('.js-products').find('.js-products__slider-arrow-right');

				const extraConfig = {
					infinite: true,
					arrows: true,
					prevArrow: left,
					nextArrow: right,
					responsive: [
						{
							breakpoint: 1351,
							settings: {
								slidesToShow: 4
							}
						},
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 3
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 640,
							settings: {
								slidesToShow: 1
							}
						}
					]
				};

				const config = {
					...baseConfig,
					...extraConfig
				};

				Sliders.runSlider($(el), config);
			// });
		});
	},

	singleProductSlider: function() {
		const itemsLength = $('.js-single-product__slider-preview .single-product__slider-preview-img').length;
		const num = window.innerWidth < 768 ? 2 : 3;
		const checkItems = itemsLength > num;

		if (($('.slider-product__slider-img').length) > 1) {
			const singleProductSliderBaseConfig = new SliderBaseConfig(1);

			const singleProductSliderExtraConfig = {
				infinite: true,
				arrows: false,
				fade: true,
				asNavFor: '.js-single-product__slider-preview',
				accessibility: false,
				draggable: checkItems,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							swipe: checkItems,
							swipeToSlide: checkItems,
							touchMove: checkItems,
							draggable: checkItems,
							accessibility: checkItems,
						}
					}
				]
			};

			const singleProductSliderConfig = {
				...singleProductSliderBaseConfig,
				...singleProductSliderExtraConfig
			};

			this.runSlider(this.$domSingleProductSlider, singleProductSliderConfig);

			Sliders.$domSingleProductPreviewSlider.slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				focusOnSelect: true,
				speed: 1000,
				arrows: true,
				dots: false,
				appendDots: $('.js-single-product__slider-preview-dots'),
				prevArrow: $('.single-product__slider-preview-arrow--left'),
				nextArrow: $('.single-product__slider-preview-arrow--right'),
				asNavFor: '.js-single-product__slider-wrapper',
				accessibility: false,
				draggable: checkItems,
				centerMode: false,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							dots: checkItems,
							arrows: false,
							focusOnSelect: true
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							dots: checkItems,
							arrows: false,
							focusOnSelect: true,
							draggable: false,
						}
					}
				]
			});
			const singleProductPreviewSliderBaseConfig = new SliderBaseConfig(3);

			const singleProductPreviewSliderExtraConfig = {
				infinite: true,
				focusOnSelect: true,
				arrows: true,
				dots: false,
				appendDots: $('.js-single-product__slider-preview-dots'),
				prevArrow: $('.single-product__slider-preview-arrow--left'),
				nextArrow: $('.single-product__slider-preview-arrow--right'),
				asNavFor: '.js-single-product__slider-wrapper',
				accessibility: false,
				draggable: checkItems,
				centerMode: false,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							dots: checkItems,
							arrows: false,
							focusOnSelect: true
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							dots: checkItems,
							arrows: false,
							focusOnSelect: true,
							draggable: false,
						}
					}
				]
			};

			const singleProductPreviewSliderConfig = {
				...singleProductPreviewSliderBaseConfig,
				...singleProductPreviewSliderExtraConfig
			};

			this.runSlider(this.$domSingleProductPreviewSlider, singleProductPreviewSliderConfig);

			$('.single-product__slider-preview-wrapper').attr('style', 'display:block !important');
		} else {
			const baseConfig = new SliderBaseConfig(1);

			const extraConfig = {
				infinite: false,
				arrows: false,
				fade: true,
				dots: false
			};

			const config = {
				...baseConfig,
				...extraConfig
			};

			this.runSlider(this.$domSingleProductSlider, config);

			$('.single-product__wrapper').addClass('single-product__wrapper--single');
		}
	},

	productInfoBoxSlider: function() {
		Sliders.$domProductInfoBoxSlider.each((i, el) => {
			const left = $(el).parents('.js-products-slider').find('.products-slider__arrow-left');
			const right = $(el).parents('.js-products-slider').find('.products-slider__arrow-right');

			const baseConfig = new SliderBaseConfig(5);

			const extraConfig = {
				infinite: true,
				arrows: true,
				prevArrow: left,
				nextArrow: right,
				responsive: [
					{
						breakpoint: 1351,
						settings: {
							slidesToShow: 4
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 514,
						settings: {
							slidesToShow: 1
						}
					},
				]
			};

			const config = {
				...baseConfig,
				...extraConfig
			};

			this.runSlider($(el), config);
		});
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
